export const SLACK_CHANNELS = {
  FRONTEND_ERRORS: "frontend_errors",
  FRONTEND_INFO: "frontend_info",
  DEBUG: "debug",
} as const;
